module.exports = __webpack_public_path__ + "img/LS.c1ba466b.png";